// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}
.form-floating>.form-control-plaintext~label, .form-floating>.form-control:focus~label, .form-floating>.form-control:not(:placeholder-shown)~label, .form-floating>.form-select~label{
  transform: scale(.85em);
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


/* #divMain{
  background: #F4BC16;

  border-radius: 50%;
  width: 700px;
  height: 700px;
  transform: translateY(-300px) translateX(-50px);
  
} */
#containerMain{
  position: absolute;
  z-index: -1;
  overflow: hidden;
  width: 100%;
}
#Main{
  display: flex;
}

body{
  background-color: white;
}
.rootDiv{
  background-color:transparent;
  /* position: absolute; */
  height: 100%;
  /* height: 100%  !important; */
}
.App{
  padding: 20px;
}
*{
  --bs-offcanvas-width:300px !important
}

.CardDiv{
  width: 80%;
  padding-left: 20%;
  padding-right: 20%;
}


@media only screen and (max-width: 767px) {
  .CardDiv{
    width: 100%;
    padding-left: 0%;
    padding-right: 0%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1050px){
  .CardDiv{
    width: 100%;
    padding-left: 0%;
    padding-right: 0%;
  }
}
@media only screen and (min-width: 1050px) {
  .CardDiv{
    width: 80%;
    padding-left: 15%;
    padding-right: 15%;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;;;;;;;;GAQG;AACH;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n.form-floating>.form-control-plaintext~label, .form-floating>.form-control:focus~label, .form-floating>.form-control:not(:placeholder-shown)~label, .form-floating>.form-select~label{\n  transform: scale(.85em);\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n/* #divMain{\n  background: #F4BC16;\n\n  border-radius: 50%;\n  width: 700px;\n  height: 700px;\n  transform: translateY(-300px) translateX(-50px);\n  \n} */\n#containerMain{\n  position: absolute;\n  z-index: -1;\n  overflow: hidden;\n  width: 100%;\n}\n#Main{\n  display: flex;\n}\n\nbody{\n  background-color: white;\n}\n.rootDiv{\n  background-color:transparent;\n  /* position: absolute; */\n  height: 100%;\n  /* height: 100%  !important; */\n}\n.App{\n  padding: 20px;\n}\n*{\n  --bs-offcanvas-width:300px !important\n}\n\n.CardDiv{\n  width: 80%;\n  padding-left: 20%;\n  padding-right: 20%;\n}\n\n\n@media only screen and (max-width: 767px) {\n  .CardDiv{\n    width: 100%;\n    padding-left: 0%;\n    padding-right: 0%;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 1050px){\n  .CardDiv{\n    width: 100%;\n    padding-left: 0%;\n    padding-right: 0%;\n  }\n}\n@media only screen and (min-width: 1050px) {\n  .CardDiv{\n    width: 80%;\n    padding-left: 15%;\n    padding-right: 15%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
